import { Component } from 'react';
import './ErrorBoundary.css';

// Catches a render crash in whatever it wraps and shows a recoverable panel
// instead of leaving that whole area blank with no way back — "Close" just
// unmounts this subtree (via onClose), it doesn't reload the page, so nothing
// else in the app is disturbed.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="eb-fallback">
          <div className="eb-fallback__card">
            <h3 className="eb-fallback__title">Something went wrong</h3>
            <p className="eb-fallback__msg">
              This didn't crash the app — just this window. Your data up to the last save is safe.
            </p>
            <pre className="eb-fallback__detail">{String(this.state.error?.message || this.state.error)}</pre>
            <button className="eb-fallback__btn" onClick={this.props.onClose}>Close</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
